import { useState } from "react";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "sonner";
import { Plus } from "lucide-react";
import {
  Dialog, DialogContent, DialogHeader, DialogTitle, DialogTrigger, DialogFooter,
} from "@/components/ui/dialog";
import { post } from "@/lib/api";

const CATS = ["pilates", "yoga", "fitness", "crossfit", "boxing", "spa", "masaj", "sauna"];

export default function AddSessionDialog({ defaultDate }) {
  const qc = useQueryClient();
  const [open, setOpen] = useState(false);
  const [form, setForm] = useState({
    title: "", category: "pilates", date: defaultDate || new Date().toISOString().slice(0, 10),
    start_time: "09:00", end_time: "10:00", capacity: 12, instructor: "", credit_price: 8,
  });

  const set = (k, v) => setForm((f) => ({ ...f, [k]: v }));

  const mut = useMutation({
    mutationFn: () => post("/partner/sessions", {
      ...form, capacity: Number(form.capacity), credit_price: Number(form.credit_price),
    }),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ["partner-calendar"] });
      qc.invalidateQueries({ queryKey: ["partner-sessions"] });
      qc.invalidateQueries({ queryKey: ["partner-dashboard"] });
      toast.success("Seans eklendi");
      setOpen(false);
    },
    onError: () => toast.error("Seans eklenemedi"),
  });

  const submit = (e) => {
    e.preventDefault();
    if (!form.title || !form.instructor) return toast.error("Başlık ve eğitmen zorunlu");
    mut.mutate();
  };

  const inputCls = "w-full rounded-md border border-[#E2E8F0] bg-white px-3 py-2 text-sm outline-none focus:border-[#2D2926]";

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogTrigger asChild>
        <button data-testid="add-session-button" className="flex items-center gap-2 rounded-md bg-[#2D2926] px-4 py-2 text-sm font-medium text-white transition-colors hover:bg-[#1A1715]">
          <Plus className="h-4 w-4" /> Yeni Seans
        </button>
      </DialogTrigger>
      <DialogContent className="font-ops sm:max-w-md">
        <DialogHeader><DialogTitle>Yeni Seans Ekle</DialogTitle></DialogHeader>
        <form onSubmit={submit} className="space-y-3">
          <div>
            <label className="mb-1 block text-sm text-[#475569]">Seans adı</label>
            <input data-testid="session-title-input" className={inputCls} value={form.title} onChange={(e) => set("title", e.target.value)} placeholder="Reformer Pilates" />
          </div>
          <div className="grid grid-cols-2 gap-3">
            <div>
              <label className="mb-1 block text-sm text-[#475569]">Kategori</label>
              <select data-testid="session-category-select" className={inputCls} value={form.category} onChange={(e) => set("category", e.target.value)}>
                {CATS.map((c) => <option key={c} value={c}>{c}</option>)}
              </select>
            </div>
            <div>
              <label className="mb-1 block text-sm text-[#475569]">Eğitmen</label>
              <input data-testid="session-instructor-input" className={inputCls} value={form.instructor} onChange={(e) => set("instructor", e.target.value)} placeholder="Ayşe Demir" />
            </div>
          </div>
          <div className="grid grid-cols-3 gap-3">
            <div>
              <label className="mb-1 block text-sm text-[#475569]">Tarih</label>
              <input data-testid="session-date-input" type="date" className={inputCls} value={form.date} onChange={(e) => set("date", e.target.value)} />
            </div>
            <div>
              <label className="mb-1 block text-sm text-[#475569]">Başlangıç</label>
              <input data-testid="session-start-input" type="time" className={inputCls} value={form.start_time} onChange={(e) => set("start_time", e.target.value)} />
            </div>
            <div>
              <label className="mb-1 block text-sm text-[#475569]">Bitiş</label>
              <input data-testid="session-end-input" type="time" className={inputCls} value={form.end_time} onChange={(e) => set("end_time", e.target.value)} />
            </div>
          </div>
          <div className="grid grid-cols-2 gap-3">
            <div>
              <label className="mb-1 block text-sm text-[#475569]">Kapasite</label>
              <input data-testid="session-capacity-input" type="number" min="1" className={inputCls} value={form.capacity} onChange={(e) => set("capacity", e.target.value)} />
            </div>
            <div>
              <label className="mb-1 block text-sm text-[#475569]">Kredi fiyatı</label>
              <input data-testid="session-price-input" type="number" min="1" className={inputCls} value={form.credit_price} onChange={(e) => set("credit_price", e.target.value)} />
            </div>
          </div>
          <DialogFooter>
            <button data-testid="save-session-button" type="submit" disabled={mut.isPending} className="w-full rounded-md bg-[#2D2926] py-2.5 text-sm font-medium text-white transition-colors hover:bg-[#1A1715] disabled:opacity-70">
              {mut.isPending ? "Kaydediliyor…" : "Seansı kaydet"}
            </button>
          </DialogFooter>
        </form>
      </DialogContent>
    </Dialog>
  );
}
